import { Input, Output, EventEmitter, Component, OnInit, ChangeDetectorRef, SimpleChanges, OnChanges } from '@angular/core';
import { Product } from '../../Model/Catalog/Product';
import { HazmatClass } from '../../Model/Catalog/HazmatClass';
import { WarrantyClass } from '../../Model/Catalog/WarrantyClass';
import { UserManagementService } from '../../Services/userManagment.service';
import { CatalogService } from '../../Services/CatalogManagement/catalog.service';
import { ValidationService } from '../../Services/Validation/validation.service';
import { ViewService } from 'app/Services/view.service';
import { ProductDataSource } from 'app/Model/dataProcess/productDataSource';
import { DataSourcesService } from 'app/Services/DataProcess/datasources.service';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../Services/login.service';
import { ProductService } from 'app/Services/CatalogManagement/product.service';
import { fieldNames } from 'app/Model/FieldNames';
import { Router } from '@angular/router';

const MAIN_TEMPLATE = `
  <p><strong>Hersteller:</strong></p>
  <p>{{GPSR_MANUFACTURER_NAME}}</p>
  <p>{{GPSR_ADDRESS_STREET}}</p>
  <p>{{GPSR_ADDRESS_PLZ}} {{GPSR_ADDRESS_CITY}}</p>
  <p>{{GPSR_COUNTRY_CODE}}</p>
  `;

const SAFETY_CONTACT_TEMPLATE = `
  <br>
  <p><strong>Kontakt für Produktsicherheitsanfragen:</strong></p>
  <p>{{GPSR_CONTACT_PERSON}}</p>
  <p>Telefon: {{GPSR_SUPPORT_TEL}}</p>
  <p>E-Mail: {{GPSR_SUPPORT_MAIL}}</p>
  <p>{{GPSR_SUPPORT_WEBSITE}}</p>
  `;

const IMPORTER_TEMPLATE = `
  <br>
  <p><strong>Importeur:</strong></p>
  <p>{{IMPORTER_NAME}}</p>
  <p>{{IMPORTER_ADDRESS_STREET}}</p>
  <p>{{IMPORTER_ADDRESS_PLZ}} {{IMPORTER_ADDRESS_CITY}}</p>
  <p>{{IMPORTER_COUNTRY_CODE}}</p>
  <p>{{IMPORTER_WEBSITE}}</p>
  `;

@Component({
  selector: 'productLegal',
  templateUrl: 'productLegal.component.html',
  styleUrls: ['./productLegal.component.css']
})
export class ProductLegalComponent implements OnInit, OnChanges {
  @Input() model: Product = new Product();
  @Input() productTranslation: Product = null;
  @Input() showLinkButtons: Boolean = false;
  @Input() templateView: Boolean = false;
  @Input() selectedElements: string[] = [''];
  @Input() showDragHandle: boolean = false;
  @Input() dragFilter: string = 'noDrag';
  @Input() isPrint: Boolean = false;
  @Input() showHTMLSwitch: Boolean = true;
  @Input() warrantyClasses: WarrantyClass[] = [];
  @Input() hazmatClasses: HazmatClass[] = [];

  @Output() onValueChanged = new EventEmitter<{
    value: string;
    previousValue: string;
    index: number;
    originalEvent: Event;
  }>();
  @Output() elementSelected = new EventEmitter<string>();
  @Output() excelElementDropped = new EventEmitter<any>();

  weeeDeviceTypes = ViewService.legalWeeeDeviceTypes;
  manufacturerNames: string[] = [];

  productDataSource: ProductDataSource = null;
  productDataSources: ProductDataSource[] = [];
  countryCodes: { code: string; name: string; label: string }[] = [];
  EU_CODES = new Set<string>([
    'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK',
    'EE', 'FI', 'FR', 'DE', 'GR', 'HU', 'IE', 'IT',
    'LV', 'LT', 'LU', 'MT', 'NL', 'PL', 'PT',
    'RO', 'SK', 'SI', 'ES', 'SE'
  ]);

  formData = {
    GPSR_MANUFACTURER_NAME: '',
    GPSR_ADDRESS_STREET: '',
    GPSR_ADDRESS_PLZ: '',
    GPSR_ADDRESS_CITY: '',
    GPSR_COUNTRY_CODE: '',
    GPSR_CONTACT_PERSON: '',
    GPSR_SUPPORT_TEL: '',
    GPSR_SUPPORT_MAIL: '',
    GPSR_SUPPORT_WEBSITE: '',
    IMPORTER_NAME: '',
    IMPORTER_ADDRESS_STREET: '',
    IMPORTER_ADDRESS_PLZ: '',
    IMPORTER_ADDRESS_CITY: '',
    IMPORTER_COUNTRY_CODE: '',
    IMPORTER_WEBSITE: '',
  };

  isEuCountry: boolean = true;

  private _showHTMLEditor: Boolean = true;

  get showHTMLEditor() {
    return this._showHTMLEditor;
  }

  set showHTMLEditor(value) {
    this._showHTMLEditor = value;
  }

  get hasTranslation(): Boolean {
    if (this.productTranslation == null) {
      return false;
    }
    return true;
  }

  constructor(
    public validationService: ValidationService,
    public userManagement: UserManagementService,
    public catalogService: CatalogService,
    public dataSourceService: DataSourcesService,
    public translate: TranslateService,
    public loginService: LoginService,
    public productService: ProductService,
    private cdr: ChangeDetectorRef,
    public router: Router
  ) {
    this.jumpToDataSources = this.jumpToDataSources.bind(this);
  }

  ngOnInit() {
    this.dataSourceService.getAll(this.userManagement.loginService.currentCustomer.id).then((result) => {
      this.manufacturerNames = result.map((x) => x.name);
      this.productDataSources = result;
      this.productDataSource = result.find(
        (x) =>
          x.name == this.model.legalCharacteristic.manufacturer ||
          x.alternativeNames.includes(this.model.legalCharacteristic.manufacturer)
      );
    });
    ViewService.fetchIsoCountyCodes().then(raw => {
      const list = (raw?.length ? raw : ViewService.dropDownTerritories.map(code => ({
        code,
        name: code   
      })));

      this.countryCodes = list.map(c => ({
        ...c,
        label: `${c.name} (${c.code})`
      }));

      this.cdr.detectChanges();
    });
    this.isEuCountry = this.model?.gpsr?.countryCode ? this.EU_CODES.has(this.model?.gpsr?.countryCode) : true;
  }

  async onManufacturerChange(event) {
    if (this.templateView) {
      return this.update(event, fieldNames.productSafetyManufacturer);
    }

    

    this.productDataSource = this.productDataSources.find(
      (x) =>
        x.name == this.model.legalCharacteristic.manufacturer ||
        x.alternativeNames.includes(this.model.legalCharacteristic.manufacturer)
    );
   


    this.update(event, fieldNames.productSafetyManufacturer);
    let that = this;
    if (this.model.legalCharacteristic.manufacturer?.trim()) {
      that.model.legalCharacteristic.contact = await that.productService.getSupportContact(
        that.catalogService.catalog.id,
        that.model.id,
        that.loginService.currentCustomer.id,
        that.model.legalCharacteristic.manufacturer
      );
      that.update(event, fieldNames.productSafetyContact);
    }

    this.cdr.detectChanges();
  }

  isVirtualCatalog(): boolean {
    return this.catalogService?.catalog?.isVirtual;
  }


  update(event = null, field?: string, system: string = '-1', element: string = '-1') {

    if (field && field === "GPSR_COUNTRY_CODE" )
      this.isEuCountry = this.EU_CODES.has(event.value) || event.value == null || event.value === '';

    this.formData[field] = event.value ?? '';
    if (this.loginService.hasAddonDataSources)
      this.model.legalCharacteristic.contact = this.buildContactHtml();

    if (event) {
      event.dField = field;
      event.dSystem = system;
      event.dElement = element;
      event.createTemplateItem = true;
    }

    this.onValueChanged.emit(event);
  }

  gpsrMainFieldsAreNotEmpty(): boolean {
    const g = this.model?.gpsr;
    if (!g) {
      return false;
    }

    return [
      g.manufacturerName,
      g.address.street,
      g.address.zip,
      g.address.city,
      g.countryCode
    ].some(v => (v ?? '').toString().trim() !== '');
  }

  gpsrSafetyContactFieldsAreNotEmpty(): boolean {
    const g = this.model?.gpsr;
    if (!g) {
      return false;
    }

    return [
      g.contactPerson,
      g.supportTel,
      g.supportMail,
      g.supportWebsite
    ].some(v => (v ?? '').toString().trim() !== '');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['model'] && this.model && this.loginService.hasAddonDataSources) {
      this.renderContactHtml();      
    }
  }

  private buildContactHtml(): string {
    let html = this.model.legalCharacteristic.contact;
    if (this.gpsrMainFieldsAreNotEmpty() || this.model.legalCharacteristic.contact?.includes("Hersteller"))
      html = this.renderTemplate(MAIN_TEMPLATE, this.formData);

    if (this.gpsrSafetyContactFieldsAreNotEmpty())
      html += this.renderTemplate(SAFETY_CONTACT_TEMPLATE, this.formData);

    if (!this.isEuCountry) {
      html += this.renderTemplate(IMPORTER_TEMPLATE, this.formData);
    }
    return html;
  }

  private renderContactHtml() {
    this.syncModelToFormData();
    this.isEuCountry = this.EU_CODES.has(this.formData.GPSR_COUNTRY_CODE) || this.formData.GPSR_COUNTRY_CODE === '';
    this.model.legalCharacteristic.contact = this.buildContactHtml();
  }

  private syncModelToFormData(): void {
    const gpsr = this.model?.gpsr ?? {} as any;
    const imp = this.model?.importer ?? {} as any;

    Object.assign(this.formData, {
      GPSR_MANUFACTURER_NAME: gpsr.manufacturerName ?? '',
      GPSR_ADDRESS_STREET: gpsr.address.street ?? '',
      GPSR_ADDRESS_PLZ: gpsr.address.zip ?? '',
      GPSR_ADDRESS_CITY: gpsr.address.city ?? '',
      GPSR_COUNTRY_CODE: gpsr.countryCode ?? '',
      GPSR_CONTACT_PERSON: gpsr.contactPerson ?? '',
      GPSR_SUPPORT_TEL: gpsr.supportTel ?? '',
      GPSR_SUPPORT_MAIL: gpsr.supportMail ?? '',
      GPSR_SUPPORT_WEBSITE: gpsr.supportWebsite ?? '',
      IMPORTER_NAME: imp.importerName ?? '',
      IMPORTER_ADDRESS_STREET: imp.importerAddress.street ?? '',
      IMPORTER_ADDRESS_PLZ: imp.importerAddress.zip ?? '',
      IMPORTER_ADDRESS_CITY: imp.importerAddress.city ?? '',
      IMPORTER_COUNTRY_CODE: imp.importerCountryCode ?? '',
      IMPORTER_WEBSITE: imp.importerWebsite ?? ''
    });
  }

  renderTemplate(template, data) {
    return template.replace(/{{\s*([A-Z0-9_]+)\s*}}/g, (_, key) =>
      data[key] ?? '' 
    );
}

  showHTMLEditorChanged() {
    this.catalogService
      .getProduct(this.model.id, this.model.customerId, this.catalogService.catalog.id)
      .subscribe(() => (this.model = this.catalogService.product));
  }

  //ExcelTemplate

  public elementSelectFunction(event) {
    this.elementSelected.emit(event);
  }

  public excelElementDrop(e) {
    this.excelElementDropped.emit(e);
  }

  public readOnlyForLinkedFields(field: string, system: string = '-1', element: string = '-1'): boolean {
    if (field != null) {
      var isLinked = this.model.isFieldLinked(field, system, element);
      if (isLinked && this.model.isChild != null && this.model.isChild) {
        return true;
      }
    }
    return false;
  }

  public showClearButton(): boolean {
    return !this.templateView;
  }

  public hasMasterOrChildOrIsTranslated(): boolean {
    return this.model.hasMasterOrChild();
  }

  public isFieldLinked(field: string, system: string = '-1', element: string = '-1'): boolean {
    return this.model.isFieldLinked(field, system, element);
  }

  public toggleLinkedField(field: string, system: string = '-1', element: string = '-1', event = null) {
    var changed = this.model.toggleLinkedField(field, system, element);
    if (!changed) {
      return;
    }

    var isNowLinked = this.isFieldLinked(field, system, element);
    event.target.className = this.model.getClassForLinkedField(isNowLinked);

    if (this.model.isChild && isNowLinked) {
      event.forceReload = true;
    }

    this.update(event);
  }

  public getInitialClassForLinkedField(field: string, system: string = '-1', element: string = '-1'): string {
    var isNowLinked = this.isFieldLinked(field, system, element);
    return this.model.getClassForLinkedField(isNowLinked);
  }

  canView(name: string): boolean {
    return !this.isVirtualCatalog() && this.userManagement.canView(name);
  }
  readOnly(name: string): boolean {
    return this.isVirtualCatalog() || !this.userManagement.canEdit(name);
  }

  jumpToDataSources() {
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() =>
      this.router.navigate(["datasources"]));
  }
}
